import { render, staticRenderFns } from "./baseTeam.vue?vue&type=template&id=c6a7ad64&scoped=true"
import script from "./baseTeam.vue?vue&type=script&lang=js"
export * from "./baseTeam.vue?vue&type=script&lang=js"
import style0 from "./baseTeam.vue?vue&type=style&index=0&id=c6a7ad64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a7ad64",
  null
  
)

export default component.exports